import React from 'react';
import FinalFormInputWrapper from './FinalFormInputWrapper';
import { SelectInput } from 'components/forms';
import { FieldRenderProps } from 'react-final-form';

export interface WrapperProps extends FieldRenderProps<string> {}

const TextInputWrapper: React.FC<WrapperProps> = (props) => (
  <FinalFormInputWrapper {...props} component={SelectInput} />
);

export default TextInputWrapper;
